import React from 'react';
import './style.scss';

interface TabProps {
    title: string;
    icon?: string;
    active?: boolean;
    disabled?: boolean;
    setActive: () => void;
}

const Tab = ({ title, icon, setActive, active, disabled }: TabProps) => (
    <>
        <div className="tab-container" onClick={setActive} onKeyDown={() => {}} role="button" tabIndex={0}>
            {active ? (
                <div className={disabled ? 'tab-active disabled' : 'tab-active'}>
                    {icon && <i className="material-icons-outlined align-middle">{icon}</i>}
                    <p>{title}</p>
                </div>
            ) : (
                <div className={disabled ? 'tab disabled' : 'tab'}>
                    {icon && <i className="material-icons-outlined align-middle">{icon}</i>}
                    <p>{title}</p>
                </div>
            )}
        </div>
    </>
);

export default Tab;
